var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "racecard" }, [
    !_vm.areMeetingsLoaded
      ? _c("div", { staticClass: "loader-holder" }, [_c("loader")], 1)
      : _vm.rcconf.layout === "meeting-and-race-list"
      ? _c("div", [
          _vm.meetings && _vm.meetings.length > 0
            ? _c(
                "table",
                { staticClass: "pmtable greyrows" },
                [
                  _c("thead", [
                    _c("tr", [
                      _c("th", [_vm._v(_vm._s(_vm.$t("Racecard.Race.Title")))]),
                      _vm._v(" "),
                      _c("th", [_vm._v(_vm._s(_vm.$t("Racecard.Time.Title")))]),
                      _vm._v(" "),
                      _c("th", [
                        _vm._v(_vm._s(_vm.$t("Racecard.Conditions.Title")))
                      ]),
                      _vm._v(" "),
                      _c("th", [
                        _vm._v(_vm._s(_vm.$t("Racecard.Status.Title")))
                      ]),
                      _vm._v(" "),
                      _c("th")
                    ])
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.meetings, function(meeting) {
                    return _c(
                      "tbody",
                      { key: "meeting" + meeting.id },
                      [
                        _c("tr", { key: "meeting-head-" + meeting.id }, [
                          _c(
                            "td",
                            {
                              staticClass: "meeting-head",
                              attrs: { colspan: "5" }
                            },
                            [_vm._v(_vm._s(meeting.name))]
                          )
                        ]),
                        _vm._v(" "),
                        _vm._l(meeting.races, function(race) {
                          return _c(
                            "tr",
                            {
                              key: "race" + race.id,
                              staticClass: "clickable",
                              on: {
                                click: function($event) {
                                  return _vm.selectRace4Info(
                                    race.meetingid,
                                    race.id
                                  )
                                }
                              }
                            },
                            [
                              _c("td", { staticClass: "racenum" }, [
                                _vm._v(_vm._s(race.num))
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "racetime" }, [
                                _vm._v(
                                  _vm._s(_vm.pmFormatStartTs(race.tsstart))
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(_vm._s(race.surface) + "   "),
                                _c("i", [_vm._v(_vm._s(race.distance))])
                              ]),
                              _vm._v(" "),
                              _c(
                                "td",
                                {
                                  class:
                                    "racegsc racegsc-" +
                                    (race.gsc
                                      ? race.gsc.toLowerCase()
                                      : "unknown")
                                },
                                [_vm._v(_vm._s(race.gsc))]
                              ),
                              _vm._v(" "),
                              _vm._m(0, true)
                            ]
                          )
                        })
                      ],
                      2
                    )
                  })
                ],
                2
              )
            : _c("div", { staticClass: "no-meetings" }, [
                _c("span", [
                  _vm._v(
                    _vm._s(_vm.$t("Racecard.NO_MEETINGS_&_RACES_AVAILABLE"))
                  )
                ])
              ])
        ])
      : _vm.rcconf.layout === "meeting-list"
      ? _c("div", [
          _vm.meetings && _vm.meetings.length > 0
            ? _c("table", { staticClass: "pmtable greyrows" }, [
                _c("thead", [
                  _c("tr", [
                    _c("th", [_vm._v(_vm._s(_vm.$t("Racecard.Track.Title")))]),
                    _vm._v(" "),
                    _c("th", [_vm._v(_vm._s(_vm.$t("Racecard.Races")))]),
                    _vm._v(" "),
                    _c("th", { staticClass: "racetime" }, [
                      _vm._v(_vm._s(_vm.$t("Racecard.PostTime")))
                    ]),
                    _vm._v(" "),
                    _c("th")
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "tbody",
                  _vm._l(_vm.meetings, function(meeting) {
                    return _c(
                      "tr",
                      {
                        key: "meeting-entry-" + meeting.id,
                        staticClass: "clickable",
                        on: {
                          click: function($event) {
                            return _vm.selectMeeting4PeriodContext(meeting.id)
                          }
                        }
                      },
                      [
                        _c("td", [_vm._v(_vm._s(meeting.name))]),
                        _vm._v(" "),
                        _c("td", { staticClass: "racecount" }, [
                          _vm._v(_vm._s(meeting.races.length))
                        ]),
                        _vm._v(" "),
                        _c(
                          "td",
                          { staticClass: "racetime" },
                          [
                            meeting.races.length > 0
                              ? [
                                  _vm._v(
                                    _vm._s(
                                      _vm.pmFormatStartTs(
                                        meeting.races[0].tsstart
                                      )
                                    )
                                  )
                                ]
                              : _vm._e()
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _vm._m(1, true)
                      ]
                    )
                  }),
                  0
                )
              ])
            : _c("div", { staticClass: "no-meetings" }, [
                _c("span", [
                  _vm._v(
                    _vm._s(_vm.$t("Racecard.NO_MEETINGS_&_RACES_AVAILABLE"))
                  )
                ])
              ])
        ])
      : _vm.rcconf.layout === "meeting-races-list"
      ? _c(
          "div",
          [
            _vm.meeting
              ? [
                  _c("div", { staticClass: "pmtable-head" }, [
                    _c("div", { staticClass: "pmtable-head-line" }, [
                      _c("span", { staticClass: "pmtable-head-title" }, [
                        _vm._v(_vm._s(_vm.meeting.name))
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "pmtable-head-weather" }, [
                        _vm.meeting.goingcode
                          ? _c("span", [_vm._v(_vm._s(_vm.meeting.goingcode))])
                          : _vm._e(),
                        _vm.meeting.goingcode && _vm.meeting.weather
                          ? _c("span", [_vm._v(", ")])
                          : _vm._e(),
                        _vm.meeting.weather
                          ? _c("span", [_vm._v(_vm._s(_vm.meeting.weather))])
                          : _vm._e()
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("table", { staticClass: "pmtable greyrows" }, [
                    _c("thead", [
                      _c("tr", [
                        _c("th", [
                          _vm._v(_vm._s(_vm.$t("Racecard.Race.Title")))
                        ]),
                        _vm._v(" "),
                        _c("th", { staticClass: "racetime" }, [
                          _vm._v(_vm._s(_vm.$t("Racecard.Time.Title")))
                        ]),
                        _vm._v(" "),
                        _c("th", [
                          _vm._v(_vm._s(_vm.$t("Racecard.Status.Title")))
                        ]),
                        _vm._v(" "),
                        _c("th", { staticClass: "racemoney" }, [
                          _vm._v(_vm._s(_vm.$t("Racecard.PoolAmount.Title")))
                        ]),
                        _vm._v(" "),
                        _c("th")
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      _vm._l(_vm.races, function(race) {
                        return _c(
                          "tr",
                          {
                            key: "race" + race.id,
                            staticClass: "clickable",
                            on: {
                              click: function($event) {
                                return _vm.pmAutonavToFirstBetting(
                                  race.meetingid,
                                  race.id
                                )
                              }
                            }
                          },
                          [
                            _c("td", { staticClass: "racenum" }, [
                              _vm._v(_vm._s(race.num))
                            ]),
                            _vm._v(" "),
                            _c("td", { staticClass: "racetime" }, [
                              _vm._v(_vm._s(_vm.pmFormatStartTs(race.tsstart)))
                            ]),
                            _vm._v(" "),
                            _c(
                              "td",
                              {
                                class:
                                  "racegsc racegsc-" +
                                  (race.gsc
                                    ? race.gsc.toLowerCase()
                                    : "unknown")
                              },
                              [_vm._v(_vm._s(race.gsc))]
                            ),
                            _vm._v(" "),
                            _c(
                              "td",
                              { staticClass: "racemoney" },
                              [
                                race.totalpoolvaluesum
                                  ? [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("currency")(
                                            race.totalpoolvaluesum
                                          )
                                        )
                                      )
                                    ]
                                  : [_vm._v("--")]
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _vm._m(2, true)
                          ]
                        )
                      }),
                      0
                    )
                  ])
                ]
              : _c("div", { staticClass: "no-meetings" }, [
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm.$t("Racecard.NO_MEETINGS_&_RACES_AVAILABLE"))
                    )
                  ])
                ])
          ],
          2
        )
      : _vm.rcconf.layout === "race-list"
      ? _c("div", [
          _vm.races.length > 0
            ? _c("table", { staticClass: "pmtable greyrows" }, [
                _c("thead", [
                  _c("tr", [
                    _c("th", [_vm._v(_vm._s(_vm.$t("Racecard.Track.Title")))]),
                    _vm._v(" "),
                    _c("th", [_vm._v(_vm._s(_vm.$t("Racecard.Race.Title")))]),
                    _vm._v(" "),
                    _c("th", { staticClass: "tac" }, [
                      _vm._v(_vm._s(_vm.$t("Racecard.Time.Title")))
                    ]),
                    _vm._v(" "),
                    _c("th", { staticClass: "tac" }, [
                      _vm._v(_vm._s(_vm.$t("Racecard.PoolAmount.Title")))
                    ]),
                    _vm._v(" "),
                    _c("th")
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "tbody",
                  _vm._l(_vm.races, function(race) {
                    return _c(
                      "tr",
                      {
                        key: "race" + race.id,
                        staticClass: "clickable",
                        on: {
                          click: function($event) {
                            return _vm.selectRace4Info(race.meetingid, race.id)
                          }
                        }
                      },
                      [
                        _c("td", [_vm._v(_vm._s(race.meetingname))]),
                        _vm._v(" "),
                        _c("td", { staticClass: "racenum" }, [
                          _vm._v(_vm._s(race.num))
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "tac" }, [
                          _vm._v(_vm._s(_vm.pmFormatStartTs(race.tsstart)))
                        ]),
                        _vm._v(" "),
                        _c(
                          "td",
                          { staticClass: "tac" },
                          [
                            race.totalpoolvaluesum
                              ? [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("currency")(race.totalpoolvaluesum)
                                    )
                                  )
                                ]
                              : [_vm._v("--")]
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _vm._m(3, true)
                      ]
                    )
                  }),
                  0
                )
              ])
            : _c("div", { staticClass: "no-meetings" }, [
                _c("span", [
                  _vm._v(
                    _vm._s(_vm.$t("Racecard.NO_MEETINGS_&_RACES_AVAILABLE"))
                  )
                ])
              ])
        ])
      : _c("div", { staticClass: "no-layout" }, [
          _c("span", [_vm._v("No layout for " + _vm._s(_vm.rcconf.layout))])
        ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", { staticClass: "rpointer" }, [
      _c("span", { staticClass: "icon-right" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", { staticClass: "rpointer" }, [
      _c("span", { staticClass: "icon-right" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", { staticClass: "rpointer" }, [
      _c("span", { staticClass: "icon-right" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", { staticClass: "rpointer" }, [
      _c("span", { staticClass: "icon-right" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-344c7b48", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-344c7b48","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/parimutuel/betting/racecard.vue
// module id = null
// module chunks = 